function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ref, reactive } from "vue";
import { deepAssign } from "../utils/deep-assign";
import defaultMessages from "./lang/zh-CN";
var lang = ref("zh-CN");

var _messages = reactive({
  "zh-CN": defaultMessages
});

var Locale = {
  messages: function messages() {
    return _messages[lang.value];
  },
  use: function use(newLang, newMessages) {
    lang.value = newLang;
    this.add(_defineProperty({}, newLang, newMessages));
  },
  add: function add() {
    var newMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    deepAssign(_messages, newMessages);
  }
};
var stdin_default = Locale;
export { Locale, stdin_default as default };